import paymentGateways from 'constants/paymentGateways'

export default function getPaymentGateway(id, method) {
  const gateway = paymentGateways.find((g) => g.id === id)
  return method ? gateway?.methods.find((m) => m.id === method) : gateway
}
